import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import BrandMark from "./BrandMark";

const configuredSocials = [
  { key: "FacebookHandle", label: "Facebook", Icon: FacebookIcon },
  { key: "LinkedInHandle", label: "LinkedIn", Icon: LinkedInIcon },
  { key: "YoutubeHandle", label: "YouTube", Icon: YouTubeIcon },
  { key: "TwitterHandle", label: "X / Twitter", text: "X" },
  { key: "InstagramHandle", label: "Instagram", text: "IG" },
  { key: "TikTokHandle", label: "TikTok", text: "♪" }
];

const externalUrl = (value) => /^https?:\/\//i.test(value) ? value : `https://${value.replace(/^\/+/, "")}`;

export default function PremiumFooter({ settings = {} }) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const socials = configuredSocials.filter(({ key }) => Boolean(settings[key]));

  const handOffNewsletterInterest = (event) => {
    event.preventDefault();
    // No newsletter backend exists in the accepted frontend, so this safely hands the request to the existing contact page.
    navigate("/contact-us", { state: { source: "landing-newsletter", email } });
  };

  return (
    <footer className="pl-footer">
      <div className="pl-container">
        <div className="pl-footer__grid">
          <div className="pl-footer__brand"><BrandMark /></div>
          <div>
            <h2>Quick Links</h2>
            <ul>
              <li><a href="/#home">Home</a></li>
              <li><a href="/#services">Services</a></li>
              <li><a href="/#fleet-partners">Fleet Partners</a></li>
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact-us">Contact</Link></li>
            </ul>
          </div>
          <div>
            <h2>Support</h2>
            <ul>
              {/* No public FAQ or Help Center routes exist in the accepted frontend. */}
              <li><Link to="/contact-us">FAQs</Link></li>
              <li><Link to="/contact-us">Help Center</Link></li>
              <li><Link to="/term-condition">Terms of Service</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>
          <div>
            <h2>Connect With Us</h2>
            {socials.length ? (
              <div className="pl-socials">
                {socials.map(({ key, label, Icon, text }) => (
                  <a key={key} href={externalUrl(settings[key])} target="_blank" rel="noreferrer" aria-label={label}>
                    {Icon ? <Icon aria-hidden="true" /> : <span aria-hidden="true">{text}</span>}
                  </a>
                ))}
              </div>
            ) : <p className="pl-footer__muted">Social channels will appear here when configured.</p>}
          </div>
          <div className="pl-footer__subscribe">
            <h2>Subscribe to Updates</h2>
            <form onSubmit={handOffNewsletterInterest}>
              <label htmlFor="pl-newsletter-email" className="pl-sr-only">Email address</label>
              <span><EmailRoundedIcon aria-hidden="true" /></span>
              <input
                id="pl-newsletter-email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="Your email address"
                required
              />
              <button type="submit">Subscribe</button>
            </form>
          </div>
        </div>
        <div className="pl-footer__bottom">
          <p>© {new Date().getFullYear()} Garahex. All rights reserved.</p>
          <p>Built with <span aria-label="love">♥</span> for a Moving Philippines</p>
        </div>
      </div>
    </footer>
  );
}
